import { FC } from 'react';

import { useAudioTrigger } from '../../../../controllers/audioController/hooks';
import { ChatTabType } from '../../../../store/slices/chat/types';
import { Icon, Icons } from '../../../icons';

import styles from './ChatTabs.module.css';

interface ChatTabsProps {
  selectedTab: ChatTabType;
  onTabSelect: (tab: ChatTabType) => { payload: ChatTabType; type: 'chat/setSelectedTab' };
  isLiveSupportRead: boolean;
}

export const ChatTabs: FC<ChatTabsProps> = ({ selectedTab, onTabSelect, isLiveSupportRead }) => {
  const audioTrigger = useAudioTrigger();

  return (
    <div className={styles.chatTabs}>
      <button
        data-testid={selectedTab === ChatTabType.GameChat ? 'game-chat-tab-active' : 'game-chat-tab-inactive'}
        className={`${styles.chatTabs__button} ${
          selectedTab === ChatTabType.GameChat ? styles.chatTabs__button_active : ''
        }`}
        onClick={(): void => {
          audioTrigger.play({ name: 'menuClick' });
          onTabSelect(ChatTabType.GameChat);
        }}
      >
        <Icon icon={Icons.Chat} />
      </button>

      <button
        data-testid={
          selectedTab === ChatTabType.LiveSupportChat ? 'live-support-tab-active' : 'live-support-tab-inactive'
        }
        className={`${styles.chatTabs__button} ${
          selectedTab === ChatTabType.LiveSupportChat ? styles.chatTabs__button_active : ''
        }`}
        onClick={(): void => {
          audioTrigger.play({ name: 'menuClick' });
          onTabSelect(ChatTabType.LiveSupportChat);
        }}
      >
        <div className={styles.chatTabs__iconWrapper}>
          <Icon icon={Icons.Support} />
          {!isLiveSupportRead && <div className={styles.chatTabs__badge} />}
        </div>
      </button>
    </div>
  );
};
